<div class="flex w-full items-center h-[170px]">
  <apx-chart
    *ngIf="chartOptions"
    class="flex w-[190px] items-center justify-center h-[150px] ml-2 mr-4"
    [chart]="chartOptions.chart"
    [colors]="chartOptions.colors"
    [labels]="chartOptions.labels"
    [plotOptions]="chartOptions.plotOptions"
    [series]="chartOptions.series"
    [states]="chartOptions.states"
    [tooltip]="chartOptions.tooltip"
    [stroke]="chartOptions.stroke"
  ></apx-chart>

  <div
    class="flex align-center justify-center  text-xs font-bold  flex-grow mr-3"
    role="region"
    aria-label="Risk Level Statistics"
  >
    <div class="w-[90%] max-w-[140px]">
      <div
      *ngFor="let item of formattedData; let i = index"
      class="flex gap-2 justify-between w-full mb-2"
    >
      <div class="flex gap-2 items-center text-neutral-600">
        <div
          class="flex shrink-0 my-auto rounded-full h-[11px] w-[11px]"
          [style.background-color]="item.color"
        ></div>
        <div
          class="cursor-pointer hover:drop-shadow-md transition text-[11px] text-[#000]"
          (click)="onChartClick(item.label, i)"
        >
          {{ item.label }}
        </div>
      </div>
      <div [style.color]="item.color" class="text-[11px]">
        {{ item.count === 123456 ? 0 : item.count }}
      </div>
    </div>
    </div>
  </div>
</div>
